import { Button } from 'components';
import { useTranslations } from 'next-intl';
import { FC, useState } from 'react';
import ModalUploadContextLibrary from './ModalUploadContextLibrary';

interface IUploaderContext {
  defaultTags: string[];
  refetch: () => void;
}

const UploaderContext: FC<IUploaderContext> = ({ refetch, defaultTags }) => {
  const t = useTranslations();

  const [openModal, setOpenModal] = useState(false);

  const handleToggleModal = () => setOpenModal((oldState) => !oldState);

  return (
    <>
      <Button size="large" onClick={handleToggleModal}>
        {t('context_library.upload_file')}
      </Button>
      <ModalUploadContextLibrary
        open={openModal}
        defaultTags={defaultTags}
        onCancel={handleToggleModal}
        refetch={refetch}
      />
    </>
  );
};

export default UploaderContext;
